
import { append as append_1, choose, sumBy, collect, reduce, map as map_1, singleton as singleton_1, empty as empty_1, take, length, tryHead, contains, filter, ofArray, toArray, sortByDescending, tryFind, exists, isEmpty } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Permissions_allowsBooking, Permission, Permissions_allowsObject, Permissions_allowsInStorage, Permissions_has } from "../../../Shared/Roles.js";
import { flatten, defaultArg, unwrap, map } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../../UserPermissions.js";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { toLocalTime, toString, utcNow, date as date_1, compare } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { DeleteReminder_OpenDialog, ConfirmDialog_ConfirmReminderDialog, EditReminder_OpenDialog, NewReminder_OpenDialog } from "../Dialogs/AddReminderDialog.js";
import { Msg } from "./Types.js";
import { parse } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { StorageId__get_unwrap, StorageId as StorageId_2, DocumentId__get_unwrap, ToolId as ToolId_4 } from "../../../Shared/Shared.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { TableControl$1, Table } from "../../../Widgets/Table/Table.js";
import { ColoredDot } from "../../../Components/ColoredDot.js";
import { ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import { safeHash, equals, int32ToString, stringHash, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { split, concat, join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Calendar_Warning from "../../../../public/assets/icons/Calendar_Warning.svg";
import { FileDialog_LinkedDocumentToolType, FileDialog_LinkedEntityId, Modal_OpenLinkedDocumentModalButtonModalSheet } from "../../../Widgets/Modals/LinkedDocumentModal.js";
import { HistoryAccessProvider, OpenChangelogButtonModalSheet } from "../../../Widgets/Modals/ChangelogModal.js";
import { Feature, isFeatureEnabled } from "../../../FeatureFlip.js";
import Calendar_Add from "../../../../public/assets/icons/Calendar_Add.svg";
import Pencil from "../../../../public/assets/icons/Pencil.svg";
import Check from "../../../../public/assets/icons/Check.svg";
import Recycle_Bin_1 from "../../../../public/assets/icons/Recycle_Bin_1.svg";
import { TextDropdownButton, TextButton, Button } from "../../../Components/Button.js";
import { ModalSheet } from "../../../Components/ModalSheet.js";
import { NewReservation_AddToolWithQuantityReservationDialog } from "../Dialogs/ToolWithQuantityReservationDialog.js";
import { EditToolWithQuantityReservationDialog } from "../Dialogs/EditToolWithQuantityReservationDialog.js";
import { DeleteToolWithQuantityReservationDialog } from "../Dialogs/ToolWithQuantityDeleteReservation.js";
import { Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { DocumentTable } from "../../../Widgets/Tables/DocumentTable.js";
import { UploadType as UploadType_2 } from "../../../Widgets/Dialogs/FileUploadDialog.js";
import { unwrapStorageId } from "../../../Shared/Helper.js";
import { stateText, StateDot, targets, targetLabel, targetIcon, resolve, useDefinitions, allows as allows_1 } from "../../../InventoryStates/Display.js";
import { InventoryKind, InventoryAction } from "../../../Shared/InventoryStates.js";
import Warehouse_1 from "../../../../public/assets/icons/Warehouse_1.svg";
import Location_Building_Search from "../../../../public/assets/icons/Location_Building_Search.svg";
import Transfer_Cart from "../../../../public/assets/icons/Transfer_Cart.svg";
import Notification_Alarm_1 from "../../../../public/assets/icons/Notification_Alarm_1.svg";
import { ToolWithQuantityStockPerStorageDeleteDialog } from "../Dialogs/ToolWithQuantityDeleteStockPerStorageDialog.js";
import { MinimumStockQuantityDialog } from "../Dialogs/MinimumStockQuantityDialog.js";
import { ChangeStockDialog } from "../Dialogs/StockChangeDialog.js";
import { ChangeStorageSpaceDialog } from "../Dialogs/ChangeStorageSpaceDialog.js";
import { ChangeStorageDialog } from "../Dialogs/SwitchStorageDialog.js";
import { ToolWithQuantityDetailDto__ReadableDisplayName, Helper_historyTypeToTranslationString } from "../../../Shared/Tool.js";
import { Helper_displayHistoryComment } from "../../../Shared/Changelog.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { AssignmentProtocolDialog, AssignmentProtocolParams } from "../../../Widgets/AssignmentProtocol.js";
import { PropertyList } from "../../../Widgets/PropertyListWidget.js";
import { CustomPropertiesPropertyList } from "../../../Widgets/CustomPropertiesPropertyList.js";
import { getQueryParams, priceToString } from "../../../Common.js";
import { AreaAnchorMenu } from "../../../Widgets/AnchorMenu.js";
import { ofToolWithQuantityState } from "../../../Shared/InventoryStateMapping.js";
import Following from "../../../../public/assets/icons/Following.svg";
import Followers from "../../../../public/assets/icons/Followers.svg";
import { StartProcedureDialog } from "../../../Widgets/Procedure/StartProcedureDialog.js";
import { ProcedureEntityReferenceDto } from "../../../Shared/Procedure.js";
import { AssignToolWithQuantityDialog } from "../Dialogs/AssignToolWithQuantityDialog.js";
import { UnassignToolWithQuantityDialog } from "../Dialogs/UnassignToolWithQuantityDialog.js";
import { LostToolWithQuantityDialog } from "../Dialogs/LostToolWithQuantityDialog.js";
import { ReturnToolWithQuantityNotificationDialog } from "../Dialogs/ReturnToolWithQuantityNotificationDialog.js";
import { SelfServiceAssignToolWithQuantityDialog } from "../Dialogs/SelfServiceAssignToolWithQuantityDialog.js";
import { SelfServiceReturnToolWithQuantityDialog } from "../Dialogs/SelfServiceReturnToolWithQuantityDialog.js";
import Shipment_Search from "../../../../public/assets/icons/Shipment_Search.svg";
import { StateChangeDialog } from "../Dialogs/StateChangeDialog.js";
import Order_History from "../../../../public/assets/icons/Order_History.svg";
import { NotificationArea } from "../../../Widgets/Notification/NotificationArea.js";
import { NotificationToolType as NotificationToolType_1 } from "../../../Widgets/Notification/AcceptNotificationDialog.js";
import { MultipleImageWidget } from "../../../Widgets/Image/ImageWidget.js";
import { TextValue } from "../../../Components/Text.js";
import { QuickOverviewList } from "../../../Widgets/QuickOverviewList.js";
import { PrintLabelOptions, PrintLabelDialogFor, printLabelControl } from "../../../Labels/PrintLabelsDialog.js";
import { QrCodeTableWithStorage } from "../../../Widgets/Tables/QrCodeTable.js";
import { InventoryHistorySubject, InventoryStocktakingHistorySection, canReadStocktakingHistory } from "../../../Widgets/StocktakingHistory.js";
import { LabelInventoryKind } from "../../../Shared/Label.js";
import { OpenToolWithQuantityDeleteDialog } from "../Dialogs/ToolWithQuantityDeleteDialog.js";
import { DetailViewHeader } from "../../../Widgets/DetailViewHeader.js";
import { Badge } from "../../../Components/Badge.js";
import { TableContainerWithTabs, TableContainer } from "../../../Widgets/Container.js";
import { coverImageUrlOption } from "../../../Shared/Image.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { ChangelogTable } from "../../../Widgets/Tables/ChangelogTable.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initViewToolWithQuantity } from "./State.js";

function allowsInAnyStorage(permissions, permission, userId, stockPerStorage) {
    if (isEmpty(stockPerStorage)) {
        return Permissions_has(permissions, permission);
    }
    else {
        return exists((sps) => Permissions_allowsInStorage(permissions, permission, userId, sps.StorageId, sps.AssignedUserIds), stockPerStorage);
    }
}

function allowsForTool(permissions, permission, userId, tool) {
    if (allowsInAnyStorage(permissions, permission, userId, tool.StockPerStorage)) {
        return true;
    }
    else {
        return Permissions_allowsObject(permissions, permission, userId, undefined, map((assignment_1) => assignment_1.ReceiverId, tryFind((assignment) => (assignment.ReceiverId === userId), tool.UserAssignments)));
    }
}

function AppointmentsSection(props) {
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const canReminder = (permission) => allowsInAnyStorage(permissions, permission, props.UserData.UserId, props.ToolWithQuantity.StockPerStorage);
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsReminderDialogOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedReminderToConfirm = patternInput_3[1];
    const selectedReminderToConfirm = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedReminder = patternInput_4[1];
    const selectedReminder = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const setSelectedDeleteReminder = patternInput_5[1];
    const selectedDeleteReminder = patternInput_5[0];
    const reminders = sortByDescending((r) => r.Date, props.ToolWithQuantity.Reminders, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const now = date_1(utcNow());
    const xs_3 = toList(delay(() => append(singleton(createElement(NewReminder_OpenDialog, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsReminderDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(10, []));
        },
        ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
    })), delay(() => append(singleton(createElement(EditReminder_OpenDialog, {
        IsOpen: selectedReminder != null,
        OnClose: () => {
            setSelectedReminder(undefined);
        },
        Reminder: unwrap(selectedReminder),
        SuccessCallback: () => {
            props.Dispatch(new Msg(10, []));
        },
        ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
    })), delay(() => {
        let matchValue;
        return append((matchValue = selectedReminderToConfirm, (matchValue == null) ? (empty()) : append(singleton(createElement(ConfirmDialog_ConfirmReminderDialog, {
            IsOpen: selectedReminderToConfirm != null,
            OnClose: () => {
                setSelectedReminderToConfirm(undefined);
            },
            Reminder: matchValue,
            SuccessCallback: (isFileUploaded) => {
                props.Dispatch(new Msg(10, []));
                if (isFileUploaded) {
                    props.Dispatch(new Msg(29, []));
                }
            },
            ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
        })), delay(() => singleton(defaultOf())))), delay(() => append((selectedDeleteReminder != null) ? singleton(createElement(DeleteReminder_OpenDialog, {
            IsOpen: selectedDeleteReminder != null,
            OnClose: () => {
                setSelectedDeleteReminder(undefined);
            },
            Reminder: unwrap(selectedDeleteReminder),
            SuccessCallback: () => {
                props.Dispatch(new Msg(10, []));
                props.Dispatch(new Msg(29, []));
            },
            ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
        })) : empty(), delay(() => {
            let elems_2;
            const table = (rows) => {
                let TableRows, Options;
                return createElement(Table, (TableRows = toArray(rows), (Options = {
                    BorderStyle: "row",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["data", "desc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "singleRow",
                    SaveTableConfiguration: false,
                }, {
                    ColumnDefinitions: [new ColumnDefinition$1("state", "", t("general.done"), (reminderDate) => {
                        let elems;
                        return reminderDate.IsConfirmed ? (new CellContent(2, [createElement(ColoredDot, {
                            Color: "green",
                        })])) : ((compare(reminderDate.Date, now) > 0) ? (new CellContent(2, [createElement(ColoredDot, {
                            Color: "orange",
                        })])) : (new CellContent(2, [reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-5", "w-5"])], (elems = [Calendar_Warning()], ["children", reactApi.Children.toArray(Array.from(elems))])])))])));
                    }, "none", "text"), new ColumnDefinition$1("date", "", t("general.planned_date"), (dto) => (new CellContent(8, [dto.Date])), "dateRange", "date"), new ColumnDefinition$1("executionDate", "", t("general.execution_date"), (dto_1) => (new CellContent(8, [dto_1.ExecutionDate])), "dateRange", "date"), new ColumnDefinition$1("name", "", t("general.name"), (dto_2) => (new CellContent(0, [dto_2.Title])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_3) => (new CellContent(0, [dto_3.Description])), "none", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_4) => (new CellContent(0, [dto_4.ConfirmationComment])), "none", "text"), new ColumnDefinition$1("hasDocumentLinked", "", t("document_reminder_relation.documents_link"), (dto_5) => (new CellContent(2, [createElement(Modal_OpenLinkedDocumentModalButtonModalSheet, {
                        Documents: filter((doc) => contains(DocumentId__get_unwrap(doc.Id), dto_5.DocumentIds, {
                            Equals: (x_1, y_1) => (x_1 === y_1),
                            GetHashCode: (x_1) => (stringHash(x_1) | 0),
                        }), props.Documents),
                        LinkedEntityId: new FileDialog_LinkedEntityId(0, [dto_5.Id]),
                        OnClose: () => {
                            props.Dispatch(new Msg(29, []));
                            props.Dispatch(new Msg(10, []));
                        },
                        UploadType: new FileDialog_LinkedDocumentToolType(2, [new ToolId_4(parse(props.ToolWithQuantity.Id))]),
                        UserData: props.UserData,
                    })])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_6) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: dto_6.Id,
                    })])), "none", "button")],
                    Controls: toList(delay(() => append((isFeatureEnabled(new Feature(8, [])) && canReminder(new Permission(19, []))) ? singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_8) => {
                        setIsReminderDialogOpen(true);
                    }, false, false, "table-reminder")) : empty(), delay(() => append(canReminder(new Permission(20, [])) ? append(singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                        const matchValue_1 = tryHead(rows_1);
                        if (matchValue_1 == null) {
                        }
                        else {
                            setSelectedReminder(matchValue_1);
                        }
                    }, true, false, "table-edit")), delay(() => singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                        const matchValue_2 = tryHead(rows_2);
                        if (matchValue_2 == null) {
                        }
                        else {
                            setSelectedReminderToConfirm(matchValue_2);
                        }
                    }, true, false, "table-mark-as-done")))) : empty(), delay(() => (canReminder(new Permission(21, [])) ? singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_3) => {
                        const matchValue_3 = tryHead(rows_3);
                        if (matchValue_3 == null) {
                        }
                        else {
                            setSelectedDeleteReminder(matchValue_3);
                        }
                    }, true, false, "table-delete")) : empty()))))))),
                    Options: Options,
                    TableKey: "not-defined-table",
                    TableRows: TableRows,
                })));
            };
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_2 = toList(delay(() => append(singleton(table((length(reminders) > 5) ? take(5, reminders) : reminders)), delay(() => {
                let elems_1;
                return (length(reminders) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems_1 = [createElement(Button, {
                    ComponentState: "enabled",
                    Label: t("general.show_more_data"),
                    OnClick: () => {
                        setIsModalOpen(true);
                    },
                    TestId: "tool-with-quantity-appointment-showmoredata-button",
                    Variant: "blueButton",
                }), createElement(ModalSheet, {
                    CloseButtonTestId: "",
                    Content: table(reminders),
                    Controls: empty_1(),
                    IsModalOpen: patternInput_1[0],
                    OnClose: () => {
                        setIsModalOpen(false);
                    },
                    Title: t("general.appointments"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }))));
    }))))));
    return react.createElement(react.Fragment, {}, ...xs_3);
}

function ReservationSection(props) {
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const canEditReservation = (permission, reservation) => {
        if (allowsInAnyStorage(permissions, permission, props.UserData.UserId, props.ToolWithQuantity.StockPerStorage)) {
            return true;
        }
        else {
            return Permissions_allowsObject(permissions, permission, props.UserData.UserId, undefined, reservation.SenderInformation.ReceiverId);
        }
    };
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsReservationDialogOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedReservation = patternInput_3[1];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedDeleteReservation = patternInput_4[1];
    const selectedDeleteReservation = patternInput_4[0];
    const reservations = sortByDescending((r) => r.StartDate, props.ToolWithQuantity.Reservations, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const now = date_1(utcNow());
    const xs_2 = toList(delay(() => append(singleton(createElement(NewReservation_AddToolWithQuantityReservationDialog, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsReservationDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(10, []));
        },
        ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
        UserData: props.UserData,
    })), delay(() => {
        let matchValue;
        return append((matchValue = patternInput_3[0], (matchValue == null) ? (empty()) : singleton(createElement(EditToolWithQuantityReservationDialog, {
            IsOpen: true,
            OnClose: () => {
                setSelectedReservation(undefined);
            },
            ReservationId: matchValue.Id,
            SuccessCallback: () => {
                props.Dispatch(new Msg(10, []));
            },
            ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
            UserData: props.UserData,
        }))), delay(() => append((selectedDeleteReservation != null) ? singleton(createElement(DeleteToolWithQuantityReservationDialog, {
            IsOpen: selectedDeleteReservation != null,
            OnClose: () => {
                setSelectedDeleteReservation(undefined);
            },
            Reservation: unwrap(selectedDeleteReservation),
            SuccessCallback: () => {
                props.Dispatch(new Msg(10, []));
            },
            ToolWithQuantity: props.ToolWithQuantity,
            UserData: props.UserData,
        })) : empty(), delay(() => {
            let elems_1;
            const table = (rows) => {
                let TableRows, Options;
                return createElement(Table, (TableRows = toArray(rows), (Options = {
                    BorderStyle: "row",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["startDate", "asc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "singleRow",
                    SaveTableConfiguration: false,
                }, {
                    ColumnDefinitions: [new ColumnDefinition$1("startDate", "", t("general.start_date"), (dto) => (new CellContent(8, [dto.StartDate])), "dateRange", "date"), new ColumnDefinition$1("endDate", "", t("general.end_date"), (dto_1) => (new CellContent(8, [dto_1.EndDate])), "dateRange", "date"), new ColumnDefinition$1("receiverName", "", t("general.receiver"), (dto_2) => (new CellContent(0, [dto_2.ReceiverInformation.ReceiverName])), "none", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (dto_3) => (new CellContent(0, [int32ToString(dto_3.Quantity)])), "text", "text"), new ColumnDefinition$1("storage", "", t("general.storage"), (dto_4) => (new CellContent(0, [dto_4.StorageName])), "select", "text"), new ColumnDefinition$1("reservationName", "", t("general.name"), (dto_5) => (new CellContent(0, [dto_5.Name])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_6) => (new CellContent(0, [dto_6.Description])), "none", "text"), new ColumnDefinition$1("sender", "", t("general.created_by"), (dto_7) => (new CellContent(0, [dto_7.SenderInformation.SenderName])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_8) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: dto_8.Id,
                    })])), "none", "button")],
                    Controls: toList(delay(() => append((isFeatureEnabled(new Feature(9, [])) && Permissions_has(permissions, new Permission(11, []))) ? singleton(new TableControl$1(t("dialog.reservation.btn_title"), Calendar_Add(), (_arg_6) => {
                        setIsReservationDialogOpen(true);
                    }, false, false, "table-reservation")) : empty(), delay(() => append(Permissions_has(permissions, new Permission(12, [])) ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                        const matchValue_1 = tryHead(rows_1);
                        let matchResult, planning_1;
                        if (matchValue_1 == null) {
                            matchResult = 1;
                        }
                        else if (canEditReservation(new Permission(12, []), matchValue_1)) {
                            matchResult = 0;
                            planning_1 = matchValue_1;
                        }
                        else {
                            matchResult = 1;
                        }
                        switch (matchResult) {
                            case 0: {
                                setSelectedReservation(planning_1);
                                break;
                            }
                            case 1: {
                                break;
                            }
                        }
                    }, true, false, "table-edit")) : empty(), delay(() => (Permissions_has(permissions, new Permission(13, [])) ? singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_2) => {
                        const matchValue_2 = tryHead(rows_2);
                        let matchResult_1, planning_3;
                        if (matchValue_2 == null) {
                            matchResult_1 = 1;
                        }
                        else if (canEditReservation(new Permission(13, []), matchValue_2)) {
                            matchResult_1 = 0;
                            planning_3 = matchValue_2;
                        }
                        else {
                            matchResult_1 = 1;
                        }
                        switch (matchResult_1) {
                            case 0: {
                                setSelectedDeleteReservation(planning_3);
                                break;
                            }
                            case 1: {
                                break;
                            }
                        }
                    }, true, false, "table-delete")) : empty()))))))),
                    Options: Options,
                    TableKey: "not-defined-table",
                    TableRows: TableRows,
                })));
            };
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(table((length(reservations) > 5) ? take(5, reservations) : reservations)), delay(() => {
                let elems;
                return (length(reservations) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                    ComponentState: "enabled",
                    Label: t("general.show_more_data"),
                    OnClick: () => {
                        setIsModalOpen(true);
                    },
                    TestId: "tool-with-quantity-reservations-showmoredata-button",
                    Variant: "blueButton",
                }), createElement(ModalSheet, {
                    CloseButtonTestId: "",
                    Content: table(reservations),
                    Controls: empty_1(),
                    IsModalOpen: patternInput_1[0],
                    OnClose: () => {
                        setIsModalOpen(false);
                    },
                    Title: t("navbar.reservation"),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }))));
    }))));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

export function FormModal(props) {
    let elems;
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: defaultOf(),
        Controls: empty_1(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

export class CurrentUserAssignment extends Record {
    constructor(Id, Name, Quantity) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Quantity = Quantity;
    }
}

export function CurrentUserAssignment_$reflection() {
    return record_type("Tools.ToolWithQuantity.Details.View.CurrentUserAssignment", [], CurrentUserAssignment, () => [["Id", string_type], ["Name", string_type], ["Quantity", string_type]]);
}

function DocumentSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => {
        let Documents;
        return append(singleton(createElement(DocumentTable, (Documents = ((length(props.Documents) > 5) ? take(5, props.Documents) : props.Documents), {
            AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                EntityId: DocumentId__get_unwrap(dto.Id),
            })])), "none", "button")),
            Documents: Documents,
            OnDownloadFile: (tupledArg) => {
                props.Dispatch(new Msg(31, [tupledArg[0], tupledArg[1]]));
            },
            UploadSuccessCallback: () => {
                props.Dispatch(new Msg(29, []));
            },
            UploadType: new UploadType_2(2, [props.ToolId]),
            UserData: props.UserData,
        }))), delay(() => {
            let elems, Title;
            return (length(props.Documents) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                ComponentState: "enabled",
                Label: t("general.show_more_data"),
                OnClick: () => {
                    setIsModalOpen(true);
                },
                TestId: "tool-selectcard-tooldetail-showmoredata-button",
                Variant: "blueButton",
            }), createElement(ModalSheet, (Title = t("general.documents"), {
                CloseButtonTestId: "",
                Content: createElement(DocumentTable, {
                    AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto_1) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: DocumentId__get_unwrap(dto_1.Id),
                    })])), "none", "button")),
                    Documents: props.Documents,
                    OnDownloadFile: (tupledArg_1) => {
                        props.Dispatch(new Msg(31, [tupledArg_1[0], tupledArg_1[1]]));
                    },
                    UploadSuccessCallback: () => {
                        props.Dispatch(new Msg(29, []));
                    },
                    UploadType: new UploadType_2(2, [props.ToolId]),
                    UserData: props.UserData,
                }),
                Controls: empty_1(),
                IsModalOpen: patternInput_1[0],
                OnClose: () => {
                    setIsModalOpen(false);
                },
                Title: unwrap(Title),
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ToolsInCirculationSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsToolModalOpen = patternInput_1[1];
    const rows = map_1((d) => ({
        Name: d.ReceiverName,
        Quantity: d.Quantity,
    }), props.Tools);
    const table = (rows_1) => {
        let TableRows;
        return createElement(Table, (TableRows = toArray(rows_1), {
            ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.Name])), "none", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (row_1) => {
                let copyOfStruct;
                return new CellContent(0, [(copyOfStruct = row_1.Quantity, int32ToString(copyOfStruct))]);
            }, "none", "text")],
            Controls: empty_1(),
            Options: {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["name", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "multiRow",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows,
        }));
    };
    return reactElement("div", createObj(ofArray([["id", "tool-with-quantity-tool-section"], ["className", join(" ", ["flex", "flex-col", "bg-white"])], (elems_1 = toList(delay(() => append(singleton(table((length(rows) > 5) ? take(5, rows) : rows)), delay(() => {
        let elems;
        return (length(rows) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsToolModalOpen(true);
            },
            TestId: "tool-toolwithquantity-toolsincirculation-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, {
            CloseButtonTestId: "",
            Content: table(rows),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsToolModalOpen(false);
            },
            Title: t("tool.in_circulation"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function StockSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsToolModalOpen = patternInput_1[1];
    const permissions = usePermissions();
    const responsibleStorageIds = map_1((storage_1) => storage_1.Id, filter((storage) => Permissions_allowsInStorage(permissions, new Permission(5, []), props.UserData.UserId, unwrapStorageId(storage.Id), storage.AssignedUserIds), props.Storages));
    const gated = (action, control) => {
        if (allows_1(action, props.CurrentState)) {
            return singleton_1(control);
        }
        else {
            return empty_1();
        }
    };
    const containsStorageId = (storageId) => contains(storageId, responsibleStorageIds, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
    const patternInput_2 = reactApi.useState(undefined);
    const setIsDeleteStockPerStorageDialogOpen = patternInput_2[1];
    const isDeleteStockPerStorageDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setIsMinimumStockQuantityDialogOpen = patternInput_3[1];
    const isMinimumStockQuantityDialogOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setIsStockChangeDialogOpen = patternInput_4[1];
    const patternInput_5 = reactApi.useState(undefined);
    const setIsChangeStorageSpaceDialogOpen = patternInput_5[1];
    const isChangeStorageSpaceDialogOpen = patternInput_5[0];
    const patternInput_6 = reactApi.useState(undefined);
    const setIsChangeStorageDialogOpen = patternInput_6[1];
    const isChangeStorageDialogOpen = patternInput_6[0];
    const rows = map_1((stockPerStorage) => ({
        Location: defaultArg(map((_arg) => _arg.Name, stockPerStorage.Location), "–"),
        MinimumQuantity: unwrap(stockPerStorage.MinimumStockQuantity),
        Name: stockPerStorage.StorageName,
        QRCode: isEmpty(stockPerStorage.QRCodeIds) ? "" : reduce((e1, e2) => concat(e1, ", ", ...e2), stockPerStorage.QRCodeIds),
        Stock: stockPerStorage.Stock,
        StorageId: new StorageId_2(parse(stockPerStorage.StorageId)),
        StorageSpace: stockPerStorage.StorageSpace,
    }), props.StockPerStorages);
    const table = (rows_1) => {
        let TableRows, Options;
        return createElement(Table, (TableRows = toArray(rows_1), (Options = {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "singleRow",
            SaveTableConfiguration: false,
        }, {
            ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.storage"), (row) => (new CellContent(0, [row.Name])), "none", "text"), new ColumnDefinition$1("storage", "", t("tool.storage_space"), (row_1) => (new CellContent(0, [row_1.StorageSpace])), "none", "text"), new ColumnDefinition$1("location", "", t("general.location"), (row_2) => (new CellContent(0, [row_2.Location])), "none", "text"), new ColumnDefinition$1("stock", "", t("tool.storage_stock"), (row_3) => {
                let copyOfStruct;
                return new CellContent(0, [(copyOfStruct = row_3.Stock, int32ToString(copyOfStruct))]);
            }, "none", "text"), new ColumnDefinition$1("minimum-quantity", "", t("general.minimum_quantity"), (row_4) => {
                const matchValue = row_4.MinimumQuantity;
                return (matchValue != null) ? (new CellContent(0, [int32ToString(matchValue)])) : (new CellContent(0, [""]));
            }, "none", "text"), new ColumnDefinition$1("qrCode", "", t("general.qr_code"), (row_5) => (new CellContent(0, [row_5.QRCode])), "none", "text")],
            Controls: !!isEmpty(responsibleStorageIds) ? empty_1() : toList(delay(() => append(gated(new InventoryAction(11, []), new TableControl$1(t("tool.update_stock"), Warehouse_1(), (selectedSps) => {
                if (isEmpty(selectedSps)) {
                    setIsStockChangeDialogOpen([true, undefined]);
                }
                else {
                    const matchValue_1 = tryHead(map_1((selectedTool) => selectedTool.StorageId, selectedSps));
                    if (matchValue_1 == null) {
                    }
                    else {
                        const selectedStorageId_1 = matchValue_1;
                        if (containsStorageId(selectedStorageId_1)) {
                            setIsStockChangeDialogOpen([true, selectedStorageId_1]);
                        }
                    }
                }
            }, false, false, "tool-with-quantity-detail-update-stock")), delay(() => append(gated(new InventoryAction(11, []), new TableControl$1(t("tool.change_storage_space"), Location_Building_Search(), (selectedSps_1) => {
                if (isEmpty(selectedSps_1)) {
                }
                else {
                    const matchValue_2 = tryHead(map_1((selectedTool_1) => [selectedTool_1.StorageSpace, selectedTool_1.StorageId], selectedSps_1));
                    if (matchValue_2 == null) {
                    }
                    else {
                        const selectedStorageId_3 = matchValue_2;
                        if (containsStorageId(selectedStorageId_3[1])) {
                            setIsChangeStorageSpaceDialogOpen(selectedStorageId_3);
                        }
                    }
                }
            }, true, false, "tool-with-quantity-detail-change-storage-space")), delay(() => append(gated(new InventoryAction(4, []), new TableControl$1(t("tool.switch_storage"), Transfer_Cart(), (selectedSps_2) => {
                if (isEmpty(selectedSps_2)) {
                }
                else {
                    setIsChangeStorageDialogOpen(tryHead(map_1((selectedSps_3) => StorageId__get_unwrap(selectedSps_3.StorageId), selectedSps_2)));
                }
            }, false, false, "tool-with-quantity-detail-switch-storage")), delay(() => append(gated(new InventoryAction(11, []), new TableControl$1(t("general.minimum_quantity_update"), Notification_Alarm_1(), (selectedSps_4) => {
                if (isEmpty(selectedSps_4)) {
                }
                else {
                    const matchValue_3 = tryHead(map_1((selectedTool_2) => selectedTool_2.StorageId, selectedSps_4));
                    if (matchValue_3 == null) {
                    }
                    else {
                        const selectedStorageId_6 = matchValue_3;
                        if (containsStorageId(selectedStorageId_6)) {
                            setIsMinimumStockQuantityDialogOpen(selectedStorageId_6);
                        }
                    }
                }
            }, true, false, "tool-with-quantity-detail-minimum-quantity-update")), delay(() => singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (selectedSps_5) => {
                if (isEmpty(selectedSps_5)) {
                }
                else {
                    const matchValue_4 = tryHead(map_1((selectedTool_3) => selectedTool_3.StorageId, selectedSps_5));
                    if (matchValue_4 == null) {
                    }
                    else {
                        const selectedStorageId_8 = matchValue_4;
                        if (containsStorageId(selectedStorageId_8)) {
                            setIsDeleteStockPerStorageDialogOpen(selectedStorageId_8);
                        }
                    }
                }
            }, true, false, "tool-with-quantity-detail-delete-storage")))))))))))),
            Options: Options,
            TableKey: "not-defined-table",
            TableRows: TableRows,
        })));
    };
    return reactElement("div", createObj(ofArray([["id", "tool-with-quantity-stock-section"], ["className", join(" ", ["flex", "flex-col", "bg-white"])], (elems_1 = toList(delay(() => {
        let matchValue_5;
        return append((matchValue_5 = isDeleteStockPerStorageDialogOpen, (matchValue_5 == null) ? (empty()) : singleton(createElement(ToolWithQuantityStockPerStorageDeleteDialog, {
            IsOpen: isDeleteStockPerStorageDialogOpen != null,
            OnClose: () => {
                setIsDeleteStockPerStorageDialogOpen(undefined);
            },
            StorageId: matchValue_5,
            SuccessCallback: () => {
                props.Dispatch(new Msg(10, []));
            },
            ToolId: new ToolId_4(parse(props.Tool.Id)),
        }))), delay(() => {
            let matchValue_6;
            return append((matchValue_6 = isMinimumStockQuantityDialogOpen, (matchValue_6 == null) ? (empty()) : singleton(createElement(MinimumStockQuantityDialog, {
                IsOpen: isMinimumStockQuantityDialogOpen != null,
                OnClose: () => {
                    setIsMinimumStockQuantityDialogOpen(undefined);
                },
                StorageId: matchValue_6,
                SuccessCallback: () => {
                    props.Dispatch(new Msg(10, []));
                },
                ToolId: new ToolId_4(parse(props.Tool.Id)),
            }))), delay(() => {
                let matchValue_7, selectedStorage_2, ToolId_2;
                return append((matchValue_7 = patternInput_4[0], (matchValue_7 == null) ? (empty()) : ((selectedStorage_2 = matchValue_7, singleton(createElement(ChangeStockDialog, (ToolId_2 = (new ToolId_4(parse(props.Tool.Id))), {
                    IsOpen: selectedStorage_2[0],
                    OnClose: () => {
                        setIsStockChangeDialogOpen(undefined);
                    },
                    StorageId: unwrap(selectedStorage_2[1]),
                    Storages: filter((storage_2) => containsStorageId(storage_2.Id), props.Storages),
                    SuccessCallback: () => {
                        props.Dispatch(new Msg(10, []));
                    },
                    ToolId: ToolId_2,
                })))))), delay(() => {
                    let matchValue_8;
                    return append((matchValue_8 = isChangeStorageSpaceDialogOpen, (matchValue_8 == null) ? (empty()) : singleton(createElement(ChangeStorageSpaceDialog, {
                        IsEditableForUser: true,
                        IsOpen: isChangeStorageSpaceDialogOpen != null,
                        OnClose: () => {
                            setIsChangeStorageSpaceDialogOpen(undefined);
                        },
                        StorageId: matchValue_8[1],
                        StorageSpace: matchValue_8[0],
                        SuccessCallback: () => {
                            props.Dispatch(new Msg(10, []));
                        },
                        ToolId: new ToolId_4(parse(props.Tool.Id)),
                    }))), delay(() => append(singleton(createElement(ChangeStorageDialog, {
                        IsOpen: isChangeStorageDialogOpen != null,
                        OnClose: () => {
                            setIsChangeStorageDialogOpen(undefined);
                        },
                        SelectedStorageId: unwrap(isChangeStorageDialogOpen),
                        Storages: filter((storage_3) => containsStorageId(storage_3.Id), props.Storages),
                        SuccessCallback: () => {
                            props.Dispatch(new Msg(10, []));
                        },
                        Tool: props.Tool,
                        UserData: props.UserData,
                    })), delay(() => append(singleton(table((length(rows) > 5) ? take(5, rows) : rows)), delay(() => {
                        let elems;
                        return (length(rows) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                            ComponentState: "enabled",
                            Label: t("general.show_more_data"),
                            OnClick: () => {
                                setIsToolModalOpen(true);
                            },
                            TestId: "tool-toolwithquantity-tooldetail-showmoredata-button",
                            Variant: "blueButton",
                        }), createElement(ModalSheet, {
                            CloseButtonTestId: "",
                            Content: table(rows),
                            Controls: empty_1(),
                            IsModalOpen: patternInput_1[0],
                            OnClose: () => {
                                setIsToolModalOpen(false);
                            },
                            Title: t("tool.storage_stock"),
                        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
                    }))))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function HistorySection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsHistoryModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setAssignmentProtocolParams = patternInput_2[1];
    const table = (rows) => {
        let TableRows;
        return createElement(Table, (TableRows = toArray(rows), {
            ColumnDefinitions: [new ColumnDefinition$1("timestamp", "", t("general.date"), (dto) => (new CellContent(9, [dto.Timestamp])), "none", "dateTime"), new ColumnDefinition$1("eventType", "", t("general.event"), (dto_1) => (new CellContent(0, [defaultArg(dto_1.StateName, t(Helper_historyTypeToTranslationString(dto_1.EventType)))])), "select", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_2) => {
                const matchValue = dto_2.Event;
                return (matchValue == null) ? (new CellContent(0, [t(dto_2.Comment)])) : (new CellContent(0, [Helper_displayHistoryComment(t(matchValue), dto_2.Comment)]));
            }, "none", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (dto_3) => (new CellContent(0, [int32ToString(dto_3.Quantity)])), "none", "text"), new ColumnDefinition$1("receiver", "", t("general.receiver"), (dto_4) => {
                let matchValue_1;
                return new CellContent(0, [(matchValue_1 = dto_4.ReceiverInformation, (matchValue_1 == null) ? "" : matchValue_1.Name)]);
            }, "text", "text"), new ColumnDefinition$1("sender", "", t("general.sender"), (dto_5) => (new CellContent(0, [dto_5.SenderInformation.Name])), "text", "text"), new ColumnDefinition$1("signatureUrl", "", t("general.signature"), (dto_6) => {
                let matchValue_2;
                return new CellContent(6, [(matchValue_2 = dto_6.ReceiverInformation, (matchValue_2 != null) ? defaultArg(map((x) => x, matchValue_2.SignatureUrl), "") : "")]);
            }, "none", "image"), new ColumnDefinition$1("storage", "", t("general.storage"), (dto_7) => (new CellContent(0, [defaultArg(map((storage) => storage.Name, dto_7.StorageInformation), "")])), "text", "text"), new ColumnDefinition$1("action", "", "", (dto_8) => {
                const matchValue_3 = dto_8.EventType;
                switch (matchValue_3) {
                    case "problemReported":
                    case "updatedStock":
                    case "updatedStorage":
                    case "inMaintenance":
                    case "retired":
                    case "activate":
                    case "lost":
                    case "addedToSet":
                    case "removedFromSet":
                    case "changeInformation":
                    case "releaseDate":
                    case "deleteReleaseDate":
                    case "stocktakingStorageCorrectionBooking":
                    case "stocktakingReceiverCorrectionBooking":
                    case "stocktakingCorrectionBooking":
                    case "trackerAssigned":
                        return new CellContent(0, [""]);
                    case "trackerRemoved":
                        return new CellContent(0, [""]);
                    case "inspectionResultCreated":
                        return new CellContent(0, [""]);
                    case "procedureCompleted":
                    case "procedureCancelled": {
                        const matchValue_5 = dto_8.ProcedureId;
                        if (matchValue_5 == null) {
                            return new CellContent(0, [""]);
                        }
                        else {
                            const procedureId = matchValue_5;
                            return new CellContent(3, [t("procedure.view_results"), () => {
                                RouterModule_nav(ofArray(["procedures", procedureId, "results"]), 1, 1);
                            }]);
                        }
                    }
                    default:
                        return new CellContent(3, [t("assignment_protocol.open_assignment_protocol"), () => {
                            let AssignmentType, ReceiverName, StorageName, SignatureUrl, ImageUrl, EntityImageUrl;
                            setAssignmentProtocolParams((AssignmentType = t(Helper_historyTypeToTranslationString(dto_8.EventType)), (ReceiverName = defaultArg(map((_arg_1) => _arg_1.Name, dto_8.ReceiverInformation), ""), (StorageName = map((_arg_2) => _arg_2.Name, dto_8.StorageInformation), (SignatureUrl = flatten(map((_arg_3) => _arg_3.SignatureUrl, dto_8.ReceiverInformation)), (ImageUrl = ((props.BusinessUnitImageUrl == null) ? props.CustomerConfiguration.ProtocolConfiguration.ImageUrl : props.BusinessUnitImageUrl), (EntityImageUrl = (props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.EntityImage ? props.EntityImageUrl : undefined), new AssignmentProtocolParams(AssignmentType, props.ToolName, props.InventoryNumber, dto_8.SenderInformation.Name, ReceiverName, props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.QrCodeIds ? (isEmpty(props.QrCodeIds) ? "" : reduce((list_1, code) => concat(list_1, ", ", ...code), props.QrCodeIds)) : undefined, StorageName, dto_8.Comment, undefined, SignatureUrl, dto_8.Timestamp, ImageUrl, EntityImageUrl, dto_8.SenderImageUrls, dto_8.ReceiverImageUrls))))))));
                        }]);
                }
            }, "none", "text")],
            Controls: empty_1(),
            Options: {
                BorderStyle: "row",
                CSVDownload: true,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["timestamp", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows,
        }));
    };
    return reactElement("div", createObj(ofArray([["id", "tool-with-quantity-history-section"], ["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(AssignmentProtocolDialog, {
        AssignmentProtocolParams: unwrap(patternInput_2[0]),
        OnClose: () => {
            setAssignmentProtocolParams(undefined);
        },
    })), delay(() => append(singleton(table((length(props.HistoryRows) > 5) ? take(5, props.HistoryRows) : props.HistoryRows)), delay(() => {
        let elems;
        return (length(props.HistoryRows) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsHistoryModalOpen(true);
            },
            TestId: "tool-toolwithquantity-historysection-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, {
            CloseButtonTestId: "",
            Content: table(props.HistoryRows),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsHistoryModalOpen(false);
            },
            Title: t("history.title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function MasterDataSection(props) {
    let elems_4, elems_3;
    const t = useTranslation()[0];
    const purchaseDate = (d) => {
        if (d == null) {
            return "";
        }
        else {
            return toString(toLocalTime(d), "dd.MM.yyyy");
        }
    };
    return reactElement("div", createObj(ofArray([["id", "tool-with-quantity-masterdata-section"], ["className", join(" ", ["bg-white", "pl-10", "pt-5", "pb-5", "rounded"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-20", "h-30"])], (elems_3 = toList(delay(() => {
        let elems_1, Title, elems;
        return append(singleton(reactElement("div", createObj(singleton_1((elems_1 = [createElement(PropertyList, (Title = t("general.master_data"), {
            Properties: toList(delay(() => append(singleton({
                Label: t("tool.manufacturer"),
                TestId: "master-data-manufacturer",
                Value: props.Tool.MasterData.Manufacturer,
            }), delay(() => append(singleton({
                Label: t("tool.model"),
                TestId: "master-data-model",
                Value: props.Tool.MasterData.Model,
            }), delay(() => append(singleton({
                Label: t("tool.displayname"),
                TestId: "master-data-display-name",
                Value: props.Tool.MasterData.DisplayName,
            }), delay(() => append(singleton({
                Label: t("tool.inventory_number"),
                TestId: "master-data-inventory-number",
                Value: props.Tool.MasterData.InventoryNumber,
            }), delay(() => append(singleton({
                Label: t("general.comment"),
                TestId: "master-data-comment",
                Value: props.Tool.MasterData.Comment,
            }), delay(() => {
                if (props.Customer.tag === 1) {
                    const matchValue_1 = props.Tool.CustomerSpecific;
                    switch (matchValue_1.tag) {
                        case 1:
                            return singleton({
                                Label: t("tool.prinzing.check_number"),
                                TestId: "master-data-prinzing-check-number",
                                Value: matchValue_1.fields[0].CheckNumber,
                            });
                        default: {
                            return empty();
                        }
                    }
                }
                else {
                    return empty();
                }
            })))))))))))),
            Title: unwrap(Title),
        })), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-8"])], (elems = [createElement(CustomPropertiesPropertyList, {
            Currency: props.Currency,
            CustomProperties: props.Tool.CustomProperties,
            Title: t("tool.custom_properties"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))), delay(() => {
            let elems_2, Title_2, p;
            const matchValue_2 = props.Tool.CommercialData;
            if (matchValue_2 == null) {
                return empty();
            }
            else {
                const commercialData = matchValue_2;
                return singleton(reactElement("div", createObj(singleton_1((elems_2 = [createElement(PropertyList, (Title_2 = t("tool.commercial_data"), {
                    Properties: ofArray([{
                        Label: t("general.supplier"),
                        TestId: "commercial-data-supplier",
                        Value: commercialData.Supplier,
                    }, {
                        Label: t("general.supplier_article_number"),
                        TestId: "commercial-data-supplier-article-number",
                        Value: commercialData.SupplierArticleNumber,
                    }, {
                        Label: t("general.purchase_price"),
                        TestId: "commercial-data-purchase-price",
                        Value: (p = commercialData.PurchasePrice, (p == null) ? "" : priceToString(p, props.Currency)),
                    }, {
                        Label: t("general.purchase_date"),
                        TestId: "commercial-data-purchase-date",
                        Value: purchaseDate(commercialData.PurchaseDate),
                    }, {
                        Label: t("general.gurantee_date"),
                        TestId: "commercial-data-guarantee-date",
                        Value: purchaseDate(commercialData.WarrantyDate),
                    }, {
                        Label: t("general.comment"),
                        TestId: "commercial-data-comment",
                        Value: commercialData.Comment,
                    }]),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])))));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function ToolDetailsAreaAnchorMenu(props) {
    let elems;
    const patternInput = reactApi.useState("tool-with-quantity-overview-section");
    const t = useTranslation()[0];
    const permissions = usePermissions();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["print:hidden"])], (elems = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => append(singleton({
            Id: "tool-with-quantity-overview-section",
            Label: t("general.overview"),
        }), delay(() => append(singleton({
            Id: "tool-with-quantity-masterdata-section",
            Label: t("general.master_data"),
        }), delay(() => append((props.CanReadReminders && (isFeatureEnabled(new Feature(9, [])) ? true : isFeatureEnabled(new Feature(8, [])))) ? singleton({
            Id: "appointments-section-id",
            Label: t("general.appointments"),
        }) : empty(), delay(() => append(singleton({
            Id: "reservations-section-id",
            Label: t("navbar.reservation"),
        }), delay(() => append(singleton({
            Id: "tool-with-quantity-stock-section",
            Label: t("tool.storage_stock"),
        }), delay(() => append(singleton({
            Id: "tool-with-quantity-tool-section",
            Label: t("tool.in_circulation"),
        }), delay(() => append(singleton({
            Id: "tool-with-quantity-document-section",
            Label: t("general.documents"),
        }), delay(() => append(singleton({
            Id: "barcodes-section-id",
            Label: t("general.qr_code"),
        }), delay(() => append(props.CanReadStocktakings ? singleton({
            Id: "stocktakings-section-id",
            Label: t("stocktaking.history.title"),
        }) : empty(), delay(() => (allowsInAnyStorage(permissions, new Permission(32, []), props.UserData.UserId, props.StockPerStorage) ? singleton({
            Id: "tool-with-quantity-history-section",
            Label: t("general.history"),
        }) : empty()))))))))))))))))))))),
        OnSelectAnchor: patternInput[1],
        SelectedAnchor: patternInput[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function OverView(props) {
    let elems_19;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const assignedUserIds = collect((sps) => sps.AssignedUserIds, props.Tool.StockPerStorage);
    const canAssign = Permissions_allowsBooking(permissions, new Permission(6, []), props.UserData.UserId, assignedUserIds, false);
    const canReturn = Permissions_allowsBooking(permissions, new Permission(7, []), props.UserData.UserId, assignedUserIds, false);
    const canChangeState = allowsInAnyStorage(permissions, new Permission(4, []), props.UserData.UserId, props.Tool.StockPerStorage);
    const canUpdateDocuments = allowsInAnyStorage(permissions, new Permission(27, []), props.UserData.UserId, props.Tool.StockPerStorage);
    const definitions = useDefinitions();
    const currentState = resolve(definitions, props.Tool.StateKey, ofToolWithQuantityState(props.Tool.State));
    const allows = (action) => allows_1(action, currentState);
    const patternInput_1 = reactApi.useState(false);
    const setIsAssignDialogOpen = patternInput_1[1];
    const isAssignDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsUnassignDialogOpen = patternInput_2[1];
    const isUnassignDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsLostDialogOpen = patternInput_3[1];
    const isLostDialogOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedTarget = patternInput_4[1];
    const patternInput_5 = reactApi.useState(false);
    const setIsReturnNotificationDialogOpen = patternInput_5[1];
    const isReturnNotificationDialogOpen = patternInput_5[0];
    const patternInput_6 = reactApi.useState(false);
    const setIsSelfServiceAssignDialogOpen = patternInput_6[1];
    const isSelfServiceAssignDialogOpen = patternInput_6[0];
    const patternInput_7 = reactApi.useState(false);
    const setIsSelfServiceReturnDialogOpen = patternInput_7[1];
    const isSelfServiceReturnDialogOpen = patternInput_7[0];
    const patternInput_8 = reactApi.useState(false);
    const setIsStartProcedureDialogOpen = patternInput_8[1];
    const isStartProcedureDialogOpen = patternInput_8[0];
    const storage = sumBy((value) => (value.Stock | 0), props.Tool.StockPerStorage, {
        GetZero: () => 0,
        Add: (x, y) => ((x + y) | 0),
    }) | 0;
    const assignedUsers = sumBy((value_1) => (value_1.Quantity | 0), props.Tool.UserAssignments, {
        GetZero: () => 0,
        Add: (x_1, y_1) => ((x_1 + y_1) | 0),
    }) | 0;
    const actionButtons = toList(delay(() => {
        let Label;
        return append((canAssign && allows(new InventoryAction(0, []))) ? singleton(createElement(TextButton, (Label = t("general.assign"), {
            ComponentState: "enabled",
            Icon: Following(),
            Label: Label,
            OnClick: () => {
                setIsAssignDialogOpen(true);
            },
            TestId: "tool-toolwithquantity-overview-assign-button",
            Variant: "default",
        }))) : empty(), delay(() => {
            let Label_1;
            return (canReturn && allows(new InventoryAction(3, []))) ? singleton(createElement(TextButton, (Label_1 = t("general.take_back"), {
                ComponentState: "enabled",
                Icon: Followers(),
                Label: Label_1,
                OnClick: () => {
                    setIsUnassignDialogOpen(true);
                },
                TestId: "tool-toolwithquantity-overview-unassign-button",
                Variant: "default",
            }))) : empty();
        }));
    }));
    return reactElement("div", createObj(ofArray([["id", "tool-with-quantity-overview-section"], ["className", join(" ", ["flex", "flex-col", "grow"])], (elems_19 = toList(delay(() => append(isStartProcedureDialogOpen ? singleton(createElement(StartProcedureDialog, {
        EntityReference: new ProcedureEntityReferenceDto(1, [props.Tool.Id]),
        IsOpen: isStartProcedureDialogOpen,
        LabelIds: map_1((c) => parse(c.CategoryId), props.Tool.Categories),
        OnClose: () => {
            setIsStartProcedureDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(10, []));
        },
    })) : empty(), delay(() => append(isAssignDialogOpen ? singleton(createElement(AssignToolWithQuantityDialog, {
        IsOpen: isAssignDialogOpen,
        OnClose: () => {
            setIsAssignDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(10, []));
        },
        Tool: props.Tool,
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isUnassignDialogOpen ? singleton(createElement(UnassignToolWithQuantityDialog, {
        IsOpen: isUnassignDialogOpen,
        OnClose: () => {
            setIsUnassignDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(10, []));
        },
        Tool: props.Tool,
        UserData: props.UserData,
    })) : empty(), delay(() => append(isLostDialogOpen ? singleton(createElement(LostToolWithQuantityDialog, {
        IsOpen: isLostDialogOpen,
        OnClose: () => {
            setIsLostDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(10, []));
        },
        Tool: props.Tool,
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isReturnNotificationDialogOpen ? singleton(createElement(ReturnToolWithQuantityNotificationDialog, {
        IsOpen: isReturnNotificationDialogOpen,
        OnClose: () => {
            setIsReturnNotificationDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(10, []));
        },
        Tool: props.Tool,
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isSelfServiceAssignDialogOpen ? singleton(createElement(SelfServiceAssignToolWithQuantityDialog, {
        IsOpen: isSelfServiceAssignDialogOpen,
        OnClose: () => {
            setIsSelfServiceAssignDialogOpen(false);
        },
        SelfServiceStorages: filter((sps_1) => {
            if (props.CustomerConfiguration.GlobalSelfServiceStorageActive) {
                return true;
            }
            else {
                return exists((s) => {
                    if (unwrapStorageId(s.Id) === sps_1.StorageId) {
                        if (s.IsSelfService) {
                            return true;
                        }
                        else {
                            return contains(props.UserData.UserId, s.AccessByUser, {
                                Equals: (x_2, y_2) => (x_2 === y_2),
                                GetHashCode: (x_2) => (stringHash(x_2) | 0),
                            });
                        }
                    }
                    else {
                        return false;
                    }
                }, props.Storages);
            }
        }, props.Tool.StockPerStorage),
        SuccessCallback: () => {
            props.Dispatch(new Msg(10, []));
        },
        Tool: props.Tool,
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isSelfServiceReturnDialogOpen ? singleton(createElement(SelfServiceReturnToolWithQuantityDialog, {
        IsOpen: isSelfServiceReturnDialogOpen,
        OnClose: () => {
            setIsSelfServiceReturnDialogOpen(false);
        },
        SelfServiceStorages: filter((sps_2) => {
            if (props.CustomerConfiguration.GlobalSelfServiceStorageActive) {
                return true;
            }
            else {
                return exists((s_1) => {
                    if (unwrapStorageId(s_1.Id) === sps_2.StorageId) {
                        if (s_1.IsSelfService) {
                            return true;
                        }
                        else {
                            return contains(props.UserData.UserId, s_1.AccessByUser, {
                                Equals: (x_3, y_3) => (x_3 === y_3),
                                GetHashCode: (x_3) => (stringHash(x_3) | 0),
                            });
                        }
                    }
                    else {
                        return false;
                    }
                }, props.Storages);
            }
        }, props.Tool.StockPerStorage),
        SuccessCallback: () => {
            props.Dispatch(new Msg(10, []));
        },
        Tool: props.Tool,
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => {
        let elems_18, elems_2, elems, elems_1, elems_17, elems_3, elems_16;
        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "pt-8", "pb-10", "rounded", "px-12"])], (elems_18 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "mb-12"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-4"])], (elems = toList(delay(() => {
            let isSelfServiceUser, Label_2;
            return append((canAssign ? true : canReturn) ? actionButtons : ((isSelfServiceUser = (props.CustomerConfiguration.GlobalSelfServiceStorageActive ? true : exists((s_2) => {
                if (exists((sps_3) => (sps_3.StorageId === unwrapStorageId(s_2.Id)), props.Tool.StockPerStorage)) {
                    if (s_2.IsSelfService) {
                        return true;
                    }
                    else {
                        return contains(props.UserData.UserId, s_2.AccessByUser, {
                            Equals: (x_4, y_4) => (x_4 === y_4),
                            GetHashCode: (x_4) => (stringHash(x_4) | 0),
                        });
                    }
                }
                else {
                    return false;
                }
            }, props.Storages)), append(((Permissions_allowsBooking(permissions, new Permission(6, []), props.UserData.UserId, assignedUserIds, isSelfServiceUser) && allows(new InventoryAction(0, []))) && (storage > 0)) ? singleton(createElement(TextButton, (Label_2 = t("general.self_service_assign"), {
                ComponentState: "enabled",
                Icon: Following(),
                Label: Label_2,
                OnClick: () => {
                    setIsSelfServiceAssignDialogOpen(true);
                },
                TestId: "twq-detail-self-service-assign-button",
                Variant: "default",
            }))) : empty(), delay(() => {
                let Label_3, Label_4;
                return Permissions_allowsBooking(permissions, new Permission(7, []), props.UserData.UserId, assignedUserIds, exists((ua) => (ua.ReceiverId === props.UserData.UserId), props.Tool.UserAssignments)) ? (((isSelfServiceUser && props.CustomerConfiguration.IsStorageSelfServiceUserAuthorisedToReturnToolsWithoutNotification) && allows(new InventoryAction(3, []))) ? singleton(createElement(TextButton, (Label_3 = t("general.self_service_return"), {
                    ComponentState: "enabled",
                    Icon: Followers(),
                    Label: Label_3,
                    OnClick: () => {
                        setIsSelfServiceReturnDialogOpen(true);
                    },
                    TestId: "twq-detail-self-service-return-button",
                    Variant: "default",
                }))) : (allows(new InventoryAction(2, [])) ? singleton(createElement(TextButton, (Label_4 = t("general.request_return"), {
                    ComponentState: "enabled",
                    Icon: Followers(),
                    Label: Label_4,
                    OnClick: () => {
                        setIsReturnNotificationDialogOpen(true);
                    },
                    TestId: "twq-detail-return-notification-button",
                    Variant: "default",
                }))) : empty())) : empty();
            })))), delay(() => (canChangeState ? append(singleton(reactElement("div", {
                className: join(" ", ["grow"]),
            })), delay(() => {
                let Label_5;
                return singleton(createElement(TextButton, (Label_5 = t("general.report_lost"), {
                    ComponentState: "enabled",
                    Icon: Shipment_Search(),
                    Label: Label_5,
                    OnClick: () => {
                        setIsLostDialogOpen(true);
                    },
                    TestId: "tool-toolwithquantity-overview-lost-button",
                    Variant: "default",
                })));
            })) : empty())));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "items-center"])], (elems_1 = toList(delay(() => {
            let matchValue;
            return append((matchValue = patternInput_4[0], (matchValue == null) ? (empty()) : singleton(createElement(StateChangeDialog, {
                IsOpen: true,
                OnClose: () => {
                    setSelectedTarget(undefined);
                },
                SuccessCallback: () => {
                    props.Dispatch(new Msg(10, []));
                },
                Target: matchValue,
                ToolWithQuantity: props.Tool,
            }))), delay(() => {
                let Label_6;
                return append((props.HasManualHooks && allows(new InventoryAction(7, []))) ? singleton(createElement(TextButton, (Label_6 = t("procedure.manual_start.button"), {
                    ComponentState: "enabled",
                    Icon: Order_History(),
                    Label: Label_6,
                    OnClick: () => {
                        setIsStartProcedureDialogOpen(true);
                    },
                    TestId: "twq-detail-start-procedure-button",
                    Variant: "default",
                }))) : empty(), delay(() => {
                    const statusElements = map_1((target_1) => {
                        const Icon_7 = targetIcon(target_1);
                        return {
                            DisplayName: targetLabel(t, target_1),
                            Icon: unwrap(Icon_7),
                            OnClick: () => {
                                setSelectedTarget(target_1);
                            },
                        };
                    }, targets(props.AccountSettings, new InventoryKind(2, []), currentState, definitions));
                    return (canChangeState && !isEmpty(statusElements)) ? singleton(createElement(TextDropdownButton, {
                        Classes: empty_1(),
                        ComponentState: "enabled",
                        DisplayArrow: true,
                        DisplayDivider: false,
                        Elements: statusElements,
                        Label: t("general.change_status"),
                        TestId: "twq-detail-change-status-dropdown",
                    })) : empty();
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement(NotificationArea, {
            IsCurrentUserStorageResponsible: canReturn,
            NotificationToolType: new NotificationToolType_1(1, []),
            Notifications: props.Notifications,
            OnUpdate: () => {
                props.Dispatch(new Msg(10, []));
            },
            UserData: props.UserData,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-x-16", "gap-y-6", "mb-8"])], (elems_17 = [reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-full"])], (elems_3 = [createElement(MultipleImageWidget, {
            CanEditImage: canUpdateDocuments,
            ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
            FormImages: props.ToolImages,
            Images: map_1((image) => ({
                ImageUrl: image.ImageUrl,
                Position: image.Position,
            }), props.Tool.ToolImages),
            OnImagesChanged: (images) => {
                props.Dispatch(new Msg(13, [images]));
            },
            OnSave: () => {
                props.Dispatch(new Msg(14, []));
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "ml-10"])], (elems_16 = toList(delay(() => append(singleton(reactElement("div", {
            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
            children: t("general.state"),
        })), delay(() => {
            let elems_5, elems_4;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-1"])], (elems_4 = [createElement(StateDot, {
                Definition: resolve(definitions, props.Tool.StateKey, ofToolWithQuantityState(props.Tool.State)),
            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement(TextValue, {
                FontWeight: "normal",
                TestId: "inventory-state-text",
                Text: stateText(t, resolve(definitions, props.Tool.StateKey, ofToolWithQuantityState(props.Tool.State)), props.Tool.StateDate),
            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                let matchValue_1, businessUnitName, elems_7, elems_6;
                return append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? ((matchValue_1 = props.Tool.BusinessUnitName, (matchValue_1 == null) ? (empty()) : ((businessUnitName = matchValue_1, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-2"])], (elems_7 = [reactElement("div", {
                    className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                    children: t("business_units.business_unit"),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center"])], (elems_6 = [createElement(TextValue, {
                    FontWeight: "normal",
                    TestId: "tool-details-business-unit",
                    Text: businessUnitName,
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))))))) : empty()) : empty(), delay(() => {
                    let elems_8;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-full", "text-sm", "font-semibold", "mb-2"])], ["data-test-id", "tool-with-quantity-total-stock-test-id"], (elems_8 = [t("general.total_stock")], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                        let elems_10;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_10 = toList(delay(() => {
                            let elems_9;
                            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mr-1"])], (elems_9 = [createElement(ColoredDot, {
                                Color: (length(props.Storages) !== 0) ? "green" : "red",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => singleton(createElement(TextValue, {
                                FontWeight: "normal",
                                TestId: "tool-with-quantity-storage-test-id",
                                Text: `${storage} ${t("unit.piece")}`,
                            }))));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))), delay(() => {
                            let elems_11;
                            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-full", "text-sm", "font-semibold", "mb-2"])], (elems_11 = [t("tool.in_circulation")], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => {
                                let elems_12;
                                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-2"])], (elems_12 = toList(delay(() => singleton(createElement(TextValue, {
                                    FontWeight: "normal",
                                    TestId: "tool-with-quantity-assigedn-user-test-id",
                                    Text: `${assignedUsers} ${t("unit.piece")}`,
                                })))), ["children", reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                                    let matchValue_2, lastSeen, elems_14, elems_13;
                                    return append((matchValue_2 = props.Tool.LastSeen, (matchValue_2 == null) ? (empty()) : ((lastSeen = matchValue_2, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_14 = [reactElement("div", {
                                        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                        children: t("general.last_seen"),
                                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_13 = [createElement(TextValue, {
                                        FontWeight: "normal",
                                        TestId: "",
                                        Text: `${toString(toLocalTime(lastSeen.ScannedAt), "dd.MM.yyyy HH:mm")} ${t("general.last_seen_by")} ${lastSeen.ScannedByUserName} (${(lastSeen.ScanMethod === "nfc_tag") ? t("general.nfc_tag") : t("general.qr_code")})`,
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi.Children.toArray(Array.from(elems_14))])]))))))), delay(() => {
                                        let elems_15;
                                        return isFeatureEnabled(new Feature(3, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_15 = [createElement(QuickOverviewList, {
                                            Currency: props.CustomerConfiguration.Currency,
                                            Elements: {
                                                CommercialData: unwrap(props.Tool.CommercialData),
                                                Custom: toList(delay(() => {
                                                    let Label_8;
                                                    return append(singleton((Label_8 = t("tool.manufacturer"), {
                                                        Group: t("general.master_data"),
                                                        Key: "tool-manufacturer-fav-field",
                                                        Label: Label_8,
                                                        Value: props.Tool.MasterData.Manufacturer,
                                                    })), delay(() => {
                                                        let Label_9;
                                                        return append(singleton((Label_9 = t("tool.model"), {
                                                            Group: t("general.master_data"),
                                                            Key: "tool-model-fav-field",
                                                            Label: Label_9,
                                                            Value: props.Tool.MasterData.Model,
                                                        })), delay(() => {
                                                            let Label_10;
                                                            return append(singleton((Label_10 = t("tool.displayname"), {
                                                                Group: t("general.master_data"),
                                                                Key: "tool-displayname-fav-field",
                                                                Label: Label_10,
                                                                Value: props.Tool.MasterData.DisplayName,
                                                            })), delay(() => {
                                                                let Label_11;
                                                                return append(singleton((Label_11 = t("tool.inventory_number"), {
                                                                    Group: t("general.master_data"),
                                                                    Key: "tool-inventorynumber-fav-field",
                                                                    Label: Label_11,
                                                                    Value: props.Tool.MasterData.InventoryNumber,
                                                                })), delay(() => {
                                                                    let Label_12;
                                                                    if (props.UserData.Customer.tag === 1) {
                                                                        const matchValue_5 = props.Tool.CustomerSpecific;
                                                                        switch (matchValue_5.tag) {
                                                                            case 1:
                                                                                return singleton((Label_12 = t("tool.prinzing.check_number"), {
                                                                                    Group: t("general.master_data"),
                                                                                    Key: "tool-prinzing-check-number-fav-field",
                                                                                    Label: Label_12,
                                                                                    Value: matchValue_5.fields[0].CheckNumber,
                                                                                }));
                                                                            default: {
                                                                                return empty();
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        return empty();
                                                                    }
                                                                }));
                                                            }));
                                                        }));
                                                    }));
                                                })),
                                                CustomProperties: props.Tool.CustomProperties,
                                            },
                                            FormState: props.QuickOverviewDialog.FormState,
                                            IsDialogOpen: props.QuickOverviewDialog.IsOpen,
                                            OnSave: (updatedVisibleKeys) => {
                                                props.Dispatch(new Msg(0, [updatedVisibleKeys]));
                                            },
                                            SetDialogOpen: (_arg_25) => {
                                                props.Dispatch(new Msg(2, []));
                                            },
                                            UserData: props.UserData,
                                            VisibleKeys: props.UserConfiguration.QuickOverviewConfiguration.ToolWithQuantityViewVisibleFieldKeys,
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))) : empty();
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_16))])])))], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))], ["children", reactApi.Children.toArray(Array.from(elems_18))])]))));
    })))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_19))])])));
}

function BarcodeSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsPrintLabelOpen = patternInput_2[1];
    const onPrintLabel = printLabelControl(props.PrintLabel, () => {
        setIsPrintLabelOpen(true);
    });
    let tableData;
    const list_7 = collect((x) => x, map_1((stockPerStorage) => choose((qrCodeId) => {
        let StorageId;
        return (StorageId = (new StorageId_2(parse(stockPerStorage.StorageId))), {
            AssignedUserIds: stockPerStorage.AssignedUserIds,
            Location: defaultArg(map((_arg) => _arg.Name, stockPerStorage.Location), "–"),
            QrCode: qrCodeId,
            StorageId: StorageId,
            StorageName: stockPerStorage.StorageName,
            StorageSpace: stockPerStorage.StorageSpace,
        });
    }, stockPerStorage.QRCodeIds), props.StockPerStorage));
    tableData = append_1(choose((stockPerStorage_2) => {
        let StorageId_1;
        return (StorageId_1 = (new StorageId_2(parse(stockPerStorage_2.StorageId))), {
            AssignedUserIds: stockPerStorage_2.AssignedUserIds,
            Location: defaultArg(map((_arg_1) => _arg_1.Name, stockPerStorage_2.Location), "–"),
            QrCode: "",
            StorageId: StorageId_1,
            StorageName: stockPerStorage_2.StorageName,
            StorageSpace: stockPerStorage_2.StorageSpace,
        });
    }, filter((stockPerStorage_1) => isEmpty(stockPerStorage_1.QRCodeIds), props.StockPerStorage)), list_7);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(PrintLabelDialogFor, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsPrintLabelOpen(false);
        },
        Options: props.PrintLabel,
    })), delay(() => append(singleton(createElement(QrCodeTableWithStorage, {
        Data: (length(tableData) > 5) ? take(5, tableData) : tableData,
        OnAssignQrCode: (tupledArg) => {
            props.Dispatch(new Msg(21, [tupledArg[0], tupledArg[1]]));
        },
        OnDeleteQrCodes: (tupledArg_1) => {
            props.Dispatch(new Msg(23, [tupledArg_1[0], tupledArg_1[1]]));
        },
        OnPrintLabel: unwrap(onPrintLabel),
        UserData: props.UserData,
    })), delay(() => {
        let elems;
        return (length(tableData) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, {
            CloseButtonTestId: "",
            Content: createElement(QrCodeTableWithStorage, {
                Data: tableData,
                OnAssignQrCode: (value_4) => {
                },
                OnDeleteQrCodes: (value_5) => {
                },
                OnPrintLabel: unwrap(onPrintLabel),
                UserData: props.UserData,
            }),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: t("general.qr_code"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ToolWithQuantityDetail(props) {
    let elems_13, elems_12, elems, Title, SubTitle, cats, elems_11;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const currentState = resolve(useDefinitions(), props.Tool.StateKey, ofToolWithQuantityState(props.Tool.State));
    const canDelete = allowsInAnyStorage(permissions, new Permission(3, []), props.UserData.UserId, props.Tool.StockPerStorage);
    const canDuplicate = allowsInAnyStorage(permissions, new Permission(1, []), props.UserData.UserId, props.Tool.StockPerStorage);
    const canEdit = allowsInAnyStorage(permissions, new Permission(2, []), props.UserData.UserId, props.Tool.StockPerStorage) && allows_1(new InventoryAction(11, []), currentState);
    const canReadReminders = allowsForTool(permissions, new Permission(18, []), props.UserData.UserId, props.Tool);
    const canReadHistory = allowsInAnyStorage(permissions, new Permission(32, []), props.UserData.UserId, props.Tool.StockPerStorage);
    const canReadStocktakings = canReadStocktakingHistory(permissions, props.AccountSettings);
    const patternInput_1 = reactApi.useState(false);
    const setIsDeleteDialogOpen = patternInput_1[1];
    const printLabel = new PrintLabelOptions(new LabelInventoryKind(2, []), props.Tool.Id, props.CustomerConfiguration, allowsInAnyStorage(permissions, new Permission(24, []), props.UserData.UserId, props.Tool.StockPerStorage), allowsInAnyStorage(permissions, new Permission(22, []), props.UserData.UserId, props.Tool.StockPerStorage), () => {
        props.Dispatch(new Msg(10, []));
    });
    const children = reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_13 = [createElement(OpenToolWithQuantityDeleteDialog, {
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsDeleteDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(18, []));
        },
        ToolId: new ToolId_4(parse(props.Tool.Id)),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,minmax(0,80rem)]", "print:flex", "print:flex-col"])], (elems_12 = [reactElement("div", createObj(ofArray([["className", join(" ", ["col-span-2"])], (elems = [createElement(DetailViewHeader, (Title = ((props.Tool.MasterData.DisplayName !== "") ? props.Tool.MasterData.DisplayName : concat(props.Tool.MasterData.Manufacturer, " ", ...props.Tool.MasterData.Model)), (SubTitle = ((props.Tool.MasterData.DisplayName !== "") ? concat(props.Tool.MasterData.Manufacturer, " ", ...props.Tool.MasterData.Model) : undefined), {
        Badges: (cats = props.Tool.Categories, map_1((leaf) => createElement(Badge, {
            Color: leaf.ColorHex,
            Label: join(" > ", ofArray(split(leaf.CategoryName, [" > "], undefined, 0))),
            TestId: concat("category-badge-", ...leaf.CategoryId),
        }), filter((c) => !exists((o) => {
            if (o.CategoryName !== c.CategoryName) {
                return o.CategoryName.startsWith(c.CategoryName + " > ");
            }
            else {
                return false;
            }
        }, cats), cats))),
        OnBack: () => {
            RouterModule_nav(singleton_1("tools" + RouterModule_encodeQueryString(getQueryParams(undefined))), 1, 1);
        },
        OnDelete: unwrap(canDelete ? (() => {
            setIsDeleteDialogOpen(true);
        }) : undefined),
        OnDuplicate: unwrap(canDuplicate ? (() => {
            RouterModule_nav(ofArray(["toolswithquantity", props.Tool.Id, "copy" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : undefined),
        OnEdit: unwrap(canEdit ? (() => {
            RouterModule_nav(ofArray(["toolswithquantity", props.Tool.Id, "edit" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : undefined),
        SubTitle: unwrap(SubTitle),
        Title: Title,
    })))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(ToolDetailsAreaAnchorMenu, {
        CanReadReminders: canReadReminders,
        CanReadStocktakings: canReadStocktakings,
        StockPerStorage: props.Tool.StockPerStorage,
        UserData: props.UserData,
    }), reactElement("div", createObj(singleton_1((elems_11 = toList(delay(() => {
        let matchValue;
        return append(singleton(createElement(OverView, {
            AccountSettings: props.AccountSettings,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            FormState: props.State.FormState,
            HasManualHooks: (matchValue = props.State.ManualHooks, (matchValue.tag === 0) ? false : !isEmpty(matchValue.fields[0])),
            Notifications: props.Notifications,
            QuickOverviewDialog: props.QuickOverviewDialog,
            Storages: props.Storages,
            Tool: props.Tool,
            ToolImages: props.ToolImages,
            UserConfiguration: props.UserConfiguration,
            UserData: props.UserData,
        })), delay(() => {
            let elems_2, elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["pt-10"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["font-[600]", "pb-4", "text-sm"])], (elems_1 = [t("general.master_data")], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(MasterDataSection, {
                AccountSettings: props.AccountSettings,
                Currency: props.CustomerConfiguration.Currency,
                Customer: props.UserData.Customer,
                Tool: props.Tool,
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_3, Title_1;
                return append((isFeatureEnabled(new Feature(9, [])) ? true : isFeatureEnabled(new Feature(8, []))) ? append(canReadReminders ? singleton(reactElement("section", createObj(ofArray([["id", "appointments-section-id"], (elems_3 = [createElement(TableContainer, (Title_1 = t("general.appointments"), {
                    Content: createElement(AppointmentsSection, {
                        Dispatch: props.Dispatch,
                        Documents: props.Documents,
                        ReceiverNames: props.ReceiverNames,
                        ToolWithQuantity: props.Tool,
                        UserData: props.UserData,
                    }),
                    Title: unwrap(Title_1),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty(), delay(() => {
                    let elems_4, Title_2;
                    return singleton(reactElement("section", createObj(ofArray([["id", "reservations-section-id"], (elems_4 = [createElement(TableContainer, (Title_2 = t("navbar.reservation"), {
                        Content: createElement(ReservationSection, {
                            Dispatch: props.Dispatch,
                            ReceiverNames: props.ReceiverNames,
                            ToolWithQuantity: props.Tool,
                            UserData: props.UserData,
                        }),
                        Title: unwrap(Title_2),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                })) : empty(), delay(() => {
                    let elems_5, Title_3;
                    return append(singleton(reactElement("section", createObj(singleton_1((elems_5 = [createElement(TableContainer, (Title_3 = t("tool.storage_stock"), {
                        Content: createElement(StockSection, {
                            CurrentState: currentState,
                            Dispatch: props.Dispatch,
                            StockPerStorages: props.Tool.StockPerStorage,
                            Storages: props.Storages,
                            Tool: props.Tool,
                            UserData: props.UserData,
                            UserId: props.UserData.UserId,
                        }),
                        Title: unwrap(Title_3),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))]))))), delay(() => {
                        let elems_6, Title_4;
                        return append(singleton(reactElement("section", createObj(singleton_1((elems_6 = [createElement(TableContainer, (Title_4 = t("tool.in_circulation"), {
                            Content: createElement(ToolsInCirculationSection, {
                                Tools: props.Tool.UserAssignments,
                            }),
                            Title: unwrap(Title_4),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_6))]))))), delay(() => {
                            let elems_7, Title_5;
                            return append(singleton(reactElement("section", createObj(ofArray([["id", "tool-with-quantity-document-section"], (elems_7 = [createElement(TableContainer, (Title_5 = t("general.documents"), {
                                Content: createElement(DocumentSection, {
                                    Dispatch: props.Dispatch,
                                    Documents: props.Documents,
                                    IsVisibleForUser: true,
                                    ToolId: new ToolId_4(parse(props.Tool.Id)),
                                    UserData: props.UserData,
                                }),
                                Title: unwrap(Title_5),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                                let elems_8, Title_6;
                                return append(singleton(reactElement("section", createObj(ofArray([["id", "barcodes-section-id"], (elems_8 = [createElement(TableContainer, (Title_6 = t("general.qr_code"), {
                                    Content: createElement(BarcodeSection, {
                                        Dispatch: props.Dispatch,
                                        PrintLabel: printLabel,
                                        StockPerStorage: props.Tool.StockPerStorage,
                                        Storages: props.Storages,
                                        UserData: props.UserData,
                                    }),
                                    Title: unwrap(Title_6),
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                                    let elems_9, Title_7;
                                    return append(canReadStocktakings ? singleton(reactElement("section", createObj(ofArray([["id", "stocktakings-section-id"], (elems_9 = [createElement(TableContainer, (Title_7 = t("stocktaking.history.title"), {
                                        Content: createElement(InventoryStocktakingHistorySection, {
                                            Subject: new InventoryHistorySubject(0, [props.Tool.Id]),
                                        }),
                                        Title: unwrap(Title_7),
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty(), delay(() => {
                                        let elems_10, Title_8, Title_9, ToolName, QrCodeIds, Title_10, matchValue_1;
                                        return allowsInAnyStorage(permissions, new Permission(32, []), props.UserData.UserId, props.Tool.StockPerStorage) ? singleton(reactElement("section", createObj(ofArray([["id", "history-section-id"], (elems_10 = [createElement(TableContainerWithTabs, (Title_8 = t("history.title"), {
                                            Tab1: (Title_9 = t("history.events"), {
                                                Content: createElement(HistorySection, (ToolName = ToolWithQuantityDetailDto__ReadableDisplayName(props.Tool), (QrCodeIds = collect((x) => x, map_1((sps) => sps.QRCodeIds, props.Tool.StockPerStorage)), {
                                                    BusinessUnitImageUrl: unwrap(props.BusinessUnitImageUrl),
                                                    CustomerConfiguration: props.CustomerConfiguration,
                                                    EntityImageUrl: unwrap(coverImageUrlOption("", props.Tool.ToolImages)),
                                                    HistoryRows: props.History,
                                                    InventoryNumber: props.Tool.MasterData.InventoryNumber,
                                                    QrCodeIds: QrCodeIds,
                                                    ToolName: ToolName,
                                                }))),
                                                Title: Title_9,
                                            }),
                                            Tab2: (Title_10 = t("history.changes"), {
                                                Content: (matchValue_1 = props.Changelogs, (matchValue_1.tag === 0) ? createElement(Skeleton, {
                                                    Variant: "table",
                                                }) : createElement(ChangelogTable, {
                                                    Changelogs: matchValue_1.fields[0],
                                                })),
                                                OnSelect: () => {
                                                    props.Dispatch(new Msg(39, []));
                                                },
                                                Title: Title_10,
                                            }),
                                            Title: unwrap(Title_8),
                                        }))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty();
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_11))]))))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
    return createElement(HistoryAccessProvider, {
        canReadHistory: canReadHistory,
        children: children,
    });
}

export function ToolWithQuantityDetailView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initViewToolWithQuantity(tupledArg[0], tupledArg[1], tupledArg[2]), update_1, (_arg, _arg_1) => {
    }), [props.ToolId, props.UserData, usePermissions()], undefined);
    const state_1 = patternInput[0];
    let receiverNames_1;
    const matchValue = state_1.Receivers;
    receiverNames_1 = ((matchValue.tag === 0) ? empty_1() : matchValue.fields[0]);
    const matchValue_1 = state_1.Tool;
    const matchValue_2 = state_1.History;
    const matchValue_3 = state_1.Storages;
    const matchValue_4 = state_1.UserConfiguration;
    const matchValue_5 = state_1.Documents;
    const matchValue_6 = state_1.Notifications;
    const matchValue_7 = state_1.CustomerConfiguration;
    const matchValue_8 = state_1.AccountSettings;
    const matchValue_9 = state_1.BusinessUnitImageUrl;
    let matchResult, accountSettings, businessUnitImageUrl, customerConfiguration, documents, history, notifications, storages, tool, userConfiguration;
    if (matchValue_1.tag === 1) {
        if (matchValue_2.tag === 1) {
            if (matchValue_3.tag === 1) {
                if (matchValue_4.tag === 1) {
                    if (matchValue_5.tag === 1) {
                        if (matchValue_6.tag === 1) {
                            if (matchValue_7.tag === 1) {
                                if (matchValue_8.tag === 1) {
                                    if (matchValue_9.tag === 1) {
                                        matchResult = 0;
                                        accountSettings = matchValue_8.fields[0];
                                        businessUnitImageUrl = matchValue_9.fields[0];
                                        customerConfiguration = matchValue_7.fields[0];
                                        documents = matchValue_5.fields[0];
                                        history = matchValue_2.fields[0];
                                        notifications = matchValue_6.fields[0];
                                        storages = matchValue_3.fields[0];
                                        tool = matchValue_1.fields[0];
                                        userConfiguration = matchValue_4.fields[0];
                                    }
                                    else {
                                        matchResult = 1;
                                    }
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return createElement(ToolWithQuantityDetail, {
                AccountSettings: accountSettings,
                BusinessUnitImageUrl: unwrap(businessUnitImageUrl),
                Changelogs: state_1.Changelogs,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                Documents: documents,
                History: history,
                Notifications: notifications,
                QuickOverviewDialog: state_1.QuickOverviewDialog,
                ReceiverNames: receiverNames_1,
                State: state_1,
                Storages: storages,
                Tool: tool,
                ToolImages: state_1.ToolImages,
                UserConfiguration: userConfiguration,
                UserData: state_1.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

